import axios from 'axios'

const httpClient = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL_API,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  //timeout: 10000,
  // Configuración para evitar problemas CORS
  withCredentials: false,
})

httpClient.interceptors.request.use((req) => {
  console.log('Entro a interceptors 1')
  console.log(`${req.method} ${req.url}`)

  // Agregar JWT automáticamente si existe
  const user = localStorage.getItem('user')
  if (user) {
    try {
      const userData = JSON.parse(user)
      if (userData.jwt) {
        req.headers['Authorization'] = `Bearer ${userData.jwt}`
        console.log('JWT agregado automáticamente:', userData.jwt.substring(0, 50) + '...')
      }
    } catch (error) {
      console.error('Error parsing user data from localStorage:', error)
    }
  }

  // Para requests cross-origin, asegurar headers correctos
  if (req.url && req.url.includes('dptest.yucatan.gob.mx')) {
    req.headers['Access-Control-Request-Method'] = req.method.toUpperCase()
    req.headers['Access-Control-Request-Headers'] = 'content-type, Authorization'
  }

  return req
})

// Interceptor de respuesta para manejar errores CORS
httpClient.interceptors.response.use(
  response => response,
  error => {
    console.error('API Error Details:', {
      message: error.message,
      code: error.code,
      status: error.response?.status,
      statusText: error.response?.statusText,
      url: error.config?.url,
      method: error.config?.method
    })

    // Detectar errores CORS específicos
    if (error.message.includes('CORS') ||
        error.message.includes('Network Error') ||
        (error.response?.status === 0 && !error.response?.data)) {
      error.isCorsError = true
      error.userMessage = 'Error de conectividad. El servidor no permite conexiones desde esta aplicación.'
    }

    return Promise.reject(error)
  }
)

export default httpClient
